export default __webpack_public_path__ + "static/media/welpentreffen_42.df09733a.jpg";